exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-plus[data-v-77d9f3f6], .fa-wrench[data-v-77d9f3f6] {\n  color: black;\n}\n.fa-cog[data-v-77d9f3f6], .caret[data-v-77d9f3f6] {\n  color: black;\n}\n.fa-plus[data-v-77d9f3f6], .fa-cog[data-v-77d9f3f6] {\n  margin-right: 1ex;\n}\n.group-box[data-v-77d9f3f6] {\n  cursor: pointer;\n}\n.dropdownMenuButton[data-v-77d9f3f6] {\n  background-color:white;\n}\n.info-box-number[data-v-77d9f3f6] {\n  text-overflow: ellipsis;\n  /* overflow: hidden; TODO: if uncommentedn gear buttons do not work */\n}\n.small-title[data-v-77d9f3f6] {\n  font-size: 25px;\n}\n.small-margin-text[data-v-77d9f3f6] {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.no-padding-box[data-v-77d9f3f6] {\n  padding: 0px;\n  padding-left: 0px;\n  min-height: 70px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-77d9f3f6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/groups/GroupTemplate.vue
// module id = 946
// module chunks = 1